// extracted by mini-css-extract-plugin
export var bottom = "footerBottom-module--bottom--37093";
export var bottom__left = "footerBottom-module--bottom__left--e8c91";
export var bottom__right = "footerBottom-module--bottom__right--806da";
export var bottom__right__item = "footerBottom-module--bottom__right__item--4a519";